// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ju215rL5KahVipeMSYaQTQ\\=\\={animation:E3tWBL5J9kGWBfYrwCtwNw\\=\\= 2.8s cubic-bezier(0,0,.1,1) forwards;animation-fill-mode:forwards;background-color:var(--background-info);top:-52px}@keyframes E3tWBL5J9kGWBfYrwCtwNw\\=\\={15%{top:-52px}45%{background-color:var(--background-info);top:0}60%{top:0}to{background-color:var(--background-neutral);top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tradeInBanner": "Ju215rL5KahVipeMSYaQTQ==",
	"tradeInBannerAnimation": "E3tWBL5J9kGWBfYrwCtwNw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
